import { Typography } from '@mui/material'

import notifyAllImage from './images/notify-all.png'
import archiveImage from './images/archive.png'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Template details</Typography>
    <p>This page summarises the selected template, including its pass type, identifiers, issue and installation counts, and preview images. Use it to confirm you are working with the right template before changing or issuing passes.</p>

    <Typography variant='h5'>Previews</Typography>
    <p>Apple and Google previews show the template’s sample appearance. They are a design aid, not a replacement for testing: issue a test pass and inspect it on real devices before relying on a design for live passes.</p>

    <Typography variant='h5'>Template menu</Typography>
    <p>Most menu items open a dedicated page, which has its own Help panel. The following actions display a dialog:</p>
    <ul>
      <li><strong>Notify all:</strong> compose a message for every eligible installed pass issued from this template. The dialog shows the credit cost and recipient scope before confirmation.</li>
      <li><strong>Archive / unarchive:</strong> confirms the template status change. Archive a template when it should no longer be edited or used for new passes; unarchive it to resume work.</li>
    </ul>
    <img src={notifyAllImage} alt='Notify all passes dialog' />
    <img src={archiveImage} alt='Archive template dialog' />

    <Typography variant='h5'>Managed templates</Typography>
    <p>Managed event, loyalty and stamp-card templates show additional configuration. Event templates include event timing; loyalty and stamp-card templates include their customer signup form and downloadable QR-code assets.</p>

    <Typography variant='h5'>Synchronisation</Typography>
    <p>Synchronisation is now a dedicated page rather than a dialog. It identifies passes affected by a template change and lets you review the count before sending updates.</p>
  </div>
)

export default HelpText
